<template>
    <div class="containers-fluid wow fadeIn main_index_landing">
        <banner></banner>
        <cards></cards>
        <parallax></parallax>
    </div>
</template>
<script>
export default {
    name: "landing-page",
    components: {
        banner: () => import('@/components/pages/banners.vue'),
        cards: () => import('@/components/pages/cardsIndex.vue'),
        parallax: () => import('@/components/pages/secoes/Parallax.vue'),
    },
}
</script>
<style scoped>
.area-header {
    min-height: 95px;
}

.distribuicao-cards {
    display: block;
    margin: 0px auto;
    width: 75%;
    margin-top: -20px;
    /* margin-left: -50px; */
}

.posicao-parallax {
    margin-top: 0px
}

.bg-focapost {
    margin: 1px 0 0;
    padding: 1rem 0.5rem;
    width: 100%;
    background: #222327;
}

.bg-focapost .focapost {
    padding: 1.5rem;
}

.bg-focapost .focapost h5 {
    font-size: 2em;
}

.title-cpv-midias-sociais {
    color: #e98b24 !important;
}

@media only screen and (min-width: 81em) {
    .distribuicao-cards {
        display: block;
        margin: 0px auto;
        width: 75%;
        margin-top: -20px;
        /* margin-left: -50px; */
    }
}

@media only screen and (min-width: 62em) and (max-width: 81em) {
    .distribuicao-cards {
        display: block;
        margin: 0px auto;
        width: 100%;
        margin-top: -20px;
        /* margin-left: -50px; */
    }

    .bg-focapost {
        margin: 1px 0 0;
        padding: 1rem 0.5rem;
        width: 100%;
        background: #222327;
    }

    .bg-focapost .focapost {
        padding: 1.5rem;
    }

    .bg-focapost .focapost h5 {
        font-size: 1.7em;
    }
}

@media only screen and (min-width: 48em) and (max-width: 62em) {
    .main_index_landing {
        margin-top: 0px;
    }

    .distribuicao-cards {
        display: block;
        margin: 0px auto;
        width: 75%;
        margin-top: -20px;
        /* margin-left: -50px; */
    }

    .bg-focapost {
        margin: 1px 0 0;
        padding: 1rem 0.5rem;
        width: 100%;
        background: #222327;
    }

    .bg-focapost .focapost {
        padding: 1.5rem;
    }

    .bg-focapost .focapost h5 {
        font-size: 1.7em;
    }
}

@media only screen and (min-width: 36em) and (max-width: 48em) {

    .main_index_landing {
        margin-top: 0px;
    }

    .distribuicao-cards {
        display: block;
        margin: 0px 0px;
        width: 75%;
        margin-top: -20px;
        /* margin-left: -50px; */
    }

    .bg-focapost {
        margin: 1px 0 0;
        padding: 1rem 0.5rem;
        width: 100%;
        background: #222327;
    }

    .bg-focapost .focapost {
        padding: 1.5rem;
    }

    .bg-focapost .focapost h5 {
        font-size: 1.7em;
    }
}

@media only screen and (min-width: 20em) and (max-width: 36em) {
    .main_index_landing {
        margin-top: 0px;
    }

    .distribuicao-cards {
        display: block;
        margin: 0px 0px;
        width: 75%;
        margin-top: 0px;
        /* margin-left: -50px; */
    }

    .bg-focapost {
        margin: 1px 0 0;
        padding: 1rem 0.5rem;
        width: 100%;
        background: #222327;
    }

    .bg-focapost .focapost {
        padding: 1.5rem;
    }

    .bg-focapost .focapost h5 {
        font-size: 1.6em;
    }
}
</style>
